import { render, staticRenderFns } from "./forgetpassword.vue?vue&type=template&id=2570f5c2&scoped=true"
import script from "./forgetpassword.vue?vue&type=script&lang=js"
export * from "./forgetpassword.vue?vue&type=script&lang=js"
import style0 from "./forgetpassword.vue?vue&type=style&index=0&id=2570f5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2570f5c2",
  null
  
)

export default component.exports